import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import RefreshIcon from "../../../assets/header/refresh.svg";
import "../shuttle_bus_booking.css";
import { useLocation, useNavigate } from "react-router";
import { TableHeader } from "../../../components/reusableItems/header";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  ConfigData,
} from "./configData";
import { fetchSetMaximumList } from "../../../store/shuttle_bus_booking/set_maximum";
import { useEffect, useState } from "react";
import { SHUTTLE_BUS_BOOKING_SET_MAXIMUM_DETAILS } from "../../../routes";

export const ShuttleBusBookingSetMaximumListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tempData, setTempData] = useState([]);

  const { loading, set_maximum_list } = useSelector(
    (state) => state.shuttleBusSetMaximum
  );

  const userPermissions = getUserPermission();

  const viewPermssion = checkPermission(
    userPermissions,
    "bus_booking.access_maximum_config"
  );


  const getData = async (callback) => {
    dispatch(fetchSetMaximumList()).then((res) => {
      const formattedData = res.payload.map(item => ({
        ...item,
        id: item.config_id
      }));

      setTempData([...formattedData]);
    });
  };


  useEffect(() => {
    getData();
  }, []);

  const handleTableClick = (type, id) => {
    if (type === "View Details") {
      navigate(`${SHUTTLE_BUS_BOOKING_SET_MAXIMUM_DETAILS}?id=${id}`);
    }

  };

  const RefreshData = () => {
    getData();
  };




  const icons = [
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
    // {
    //   icon: ExportIcon,
    //   title: "Export",
    //   action: handleExport,
    // },
  ];


  return (
    <>
      {viewPermssion ? (
        <div className="container">



          <TableHeader title={"Set Maximum"} icons={icons} />



          {(<div className="shuttle_bus_booking_child_box_main_detail_box">


            {loading ? (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100vh - 165px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            ) : (
              <Reusable_table
                key={tempData && tempData.map(i => i.updated_on).join("-")}
                header={ConfigData}
                data={tempData}
                pagination={true}
                calculatePagi={true}
                pageChangeLoading={false}
                showRow={true}
                checkbox={false}
                //   handleTableClick={handleTableClick}
                handleAction={handleTableClick}
                maxHeight={""}
                maxWidth={"calc(100vw - 240px)"}
              />
            )}
          </div>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
